
import React from 'react';
import SectionLayout from '@/components/SectionLayout';
import CTAButton from '@/components/CTAButton';
import { ArrowRight, BookOpen, Users } from 'lucide-react';

const FinalCTASection = () => {
  return (
    <SectionLayout
      paddingY="py-16 sm:py-20 md:py-24"
      backgroundColor="bg-gradient-to-br from-[#003a70] via-[#003a70]/95 to-[#003a70]/90"
      containerWidth="medium"
      decorativeElements={
        <>
          {/* Floating elements */}
          <div className="absolute top-[20%] left-[10%] animate-float opacity-30 hidden sm:block">
            <BookOpen className="text-[#FEE6D8] h-6 w-6 fill-current" />
          </div>
          
          <div className="absolute top-[60%] right-[15%] animate-float opacity-25 hidden sm:block" style={{animationDelay: '2s'}}>
            <Users className="text-[#FEE6D8] h-4 w-4 fill-current" />
          </div>
          
          <div className="absolute bottom-[30%] left-[20%] animate-float opacity-20 hidden sm:block" style={{animationDelay: '1s'}}>
            <BookOpen className="text-[#FEE6D8] h-5 w-5 fill-current" />
          </div>
          
          {/* Gradient orbs */}
          <div className="absolute top-[25%] right-[25%] w-32 h-32 bg-gradient-to-br from-[#FEE6D8]/20 to-[#FEE6D8]/5 rounded-full blur-2xl animate-pulse opacity-60 hidden sm:block"></div>
          <div className="absolute bottom-[20%] left-[25%] w-40 h-40 bg-gradient-to-br from-[#FEE6D8]/15 to-[#FEE6D8]/5 rounded-full blur-xl animate-float opacity-50 hidden sm:block" style={{animationDelay: '1.5s'}}></div>
        </>
      }
    >
      <div className="max-w-4xl mx-auto text-center px-3 sm:px-4">
        {/* Main Heading */}
        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 sm:mb-6 md:mb-8 leading-tight">
          Ready To Get Started?
          <span className="block bg-gradient-to-r from-[#FEE6D8] to-[#FEE6D8]/80 bg-clip-text text-transparent mt-2">
            AI Assistant Business?
          </span>
        </h2>
        
        {/* Subtitle */}
        <p className="text-lg sm:text-xl md:text-2xl text-white/90 max-w-3xl mx-auto mb-8 sm:mb-10 md:mb-12 leading-relaxed px-2">
          Join the Local AI Assistant Launchpad and learn the proven system to build and scale your AI service business.
        </p>
        
        {/* Benefits List */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 mb-10 sm:mb-12 md:mb-16">
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 sm:p-5 md:p-6 border border-white/20">
            <div className="text-[#FEE6D8] font-semibold text-sm sm:text-base mb-2">✓ Complete Training</div>
            <div className="text-white/80 text-sm sm:text-base">Step-by-step video course</div>
          </div>
          
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 sm:p-5 md:p-6 border border-white/20">
            <div className="text-[#FEE6D8] font-semibold text-sm sm:text-base mb-2">✓ Community Access</div>
            <div className="text-white/80 text-sm sm:text-base">Skool community support</div>
          </div>
          
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 sm:p-5 md:p-6 border border-white/20 sm:col-span-2 lg:col-span-1">
            <div className="text-[#FEE6D8] font-semibold text-sm sm:text-base mb-2">✓ Proven System</div>
            <div className="text-white/80 text-sm sm:text-base">Launch your AI service business</div>
          </div>
        </div>
        
        {/* CTA Button */}
        <div className="flex flex-col items-center gap-4 sm:gap-6">
          <CTAButton 
            variant="accent"
            to="https://cart.deliciousmarketing.io/local-ai-assistant-launchpad/?coupon=AI-LAUNCHPAD"
            className="w-full sm:w-auto text-lg sm:text-xl md:text-2xl py-4 sm:py-5 md:py-6 px-8 sm:px-10 md:px-12 font-bold shadow-2xl hover:shadow-[#FEE6D8]/20 group transform hover:scale-105 transition-all duration-300"
          >
            <span className="flex items-center justify-center gap-3">
              Get the Launchpad Training
              <ArrowRight className="h-5 w-5 sm:h-6 sm:w-6 group-hover:translate-x-1 transition-transform" />
            </span>
          </CTAButton>
          
          <p className="text-white/70 text-sm sm:text-base max-w-md mx-auto">
            Start building your AI assistant business today
          </p>
        </div>
      </div>
    </SectionLayout>
  );
};

export default FinalCTASection;
